import {EndpointUri} from '../@types/EndpointUri';
import app from './app';

export function getEndpointUri(uri: EndpointUri, defaultValue?: string): string {
	if (typeof uri === 'string') {
		return uri;
	}

	return app('url').route(uri.route, uri.params) ?? defaultValue ?? '';
}
